import {Component, OnInit} from '@angular/core';
import {TextUtils} from "../../../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-menus-table',
    templateUrl: './menus-table.component.html',
    styleUrls: ['./menus-table.component.scss'],
    standalone: false
})
export class MenusTableComponent implements OnInit {
  isMobile = false;
  public heads: string[] = [
    TextUtils.getText('text_menuNames'),
    TextUtils.getText('text_menuItems')
  ];

  constructor() {
  }

  ngOnInit() {
  }

}
